<template>
  <div class="column">
    <q-dialog v-model="ativar">
      <q-card style="width: 80%">
        <div class="q-gutter-md">
          <q-carousel
            v-model="slide"
            transition-prev="scale"
            transition-next="scale"
            swipeable
            animated
            control-color="white"
            navigation
            padding
            arrows
            height="300px"
            class="bg-brand-1 text-white shadow-1 rounded-borders"
          >
            <q-carousel-slide
              v-for="(info, index) in infos"
              :key="index"
              :name="index"
              class="column no-wrap flex-center"
            >
              <span
                :style="{
                  color: getTitleColor(info.type),
                }"
                style="font-weight: bold; font-size: 24px"
                >{{ info.type }}</span
              >
              <div class="q-mt-md text-center">
                {{ info.text }}
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch } from "vue";

import { useStore } from "vuex";
export default {
  props: ["activeSlide", "link", "infos"],
  setup(props) {
    const slide = ref(0);
    const ativar = ref(false);
    const unidade = ref();
    const store = useStore();

    watch(
      () => props.activeSlide,
      () => {
        if (props.activeSlide == false) {
          ativar.value = true;
          return;
        }

        ativar.value = props.activeSlide;
      }
    );
    const getTitleColor = (tipo) => {
      switch (tipo) {
        case "Nunca Retirou":
          return "#8A8A8A";

        case "Atrasado":
          return "#dd2153";

        case "Ok":
          return "#85D546";

        case "Atenção":
          return "#D19600";

        default:
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value = store.state.org.unidadeData;
      }
    );

    return {
      slide,
      ativar,
      unidade,
      getTitleColor,
    };
  },
};
</script>

<style></style>
